// Mirrors server/lib/onboarding/engine.js — display rules only.
// The server stays authoritative for what is required and who may write what.
const AUTO_DATE = new Set(["Date", "Date Trained", "Date Completed"]);

export function classify(label) {
  const l = String(label || "").trim();
  if (l.includes("Signature")) return "sig";
  if (AUTO_DATE.has(l)) return "date";
  if (l === "Printed Name") return "name";
  if (l === "Initials") return "initials";
  if (/^[A-Z][a-z]+ [A-Z][a-z]+, /.test(l)) return "static";
  return "text";
}
export const isSigningLine = (el) => el.role === "employee" && el.fields.some((x) => classify(x) === "sig");
export const gridColRole = (el, c) => (el.cols ? el.cols[c] : el.role || "readonly");
export const isSectionRow = (row) => row.length >= 1 && row[0] && typeof row[0] === "object" && row[0].section;
export const cellText = (c) => (c && typeof c === "object" ? c.t : c || "");
export const checkKey = (el, i) => (el.group ? `C_${el.group}` : `C${i}`);
export const checkOptions = (el) => { const p = el.text.split("☐").map((x) => x.trim()); return p.length > 1 ? p : null; };

const TZ = "America/New_York";
export function fmtTime(iso) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("en-US", { timeZone: TZ, month: "2-digit", day: "2-digit", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" }).format(new Date(iso));
}
export function fmtDate(iso) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("en-US", { timeZone: TZ, month: "2-digit", day: "2-digit", year: "numeric" }).format(new Date(iso));
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(new Error("Could not read the file"));
    r.readAsDataURL(file);
  });
}

export const BRAND = "#154E93";
export const GOLD = "#9C7C2C";
